export enum BankIdLoginErrorCodes {
	widgetInitFailed = 400920,
	authResponseNotValid = 400921,
	authFailedOrNotCompleted = 400922,
	userWithPINNotRegistered = 400923,
	multipleUsersWithPINDetected = 400924,
	userDataDoesNotMatch = 400925,
	sessionAlreadyUsed = 400926,
	userRegisteredWithoutBankId = 400927,
}
